const router = require("app/services/router");
const ResponseForm = require("app/components/forms/ResponseForm");
const axios = require("axios");
const env = require("app/services/env");
const Trans = require('app/components/trans/Trans')

class BaseComponent extends ResponseForm {

	get baseClassName() {
		return super.baseClassName + " newsletter-component";
	}

	renderMessageAction() {
		return (<a href={router.route("home")}> translate(Gå til forsiden)</a>);
	}

	get message() {
		return this.state.message;
	}

	renderMessage() {
		return (
			<div className="response">
				<div className="message">{this.message}</div>
				{this.renderMessageAction()}
			</div>
		);
	}

}

class Subscribe extends BaseComponent {

	constructor(props) {
		super(props);

		window.addEventListener("klaviyoForms", function(e) {
			if (e.detail.type === 'submit') {
				let name   = e.detail.metaData['$first_name'];
				let email  = e.detail.metaData['$email'];
				let gender = null;
				let cart_id = env.get("checkout.cart.products.guid");

				if (e.detail.metaData['Køn'] !== undefined) {
                  gender = e.detail.metaData[translate('Køn')];
				}

				axios.post(router.route("api.tracking.klaviyo-newsletter-subscribe"), {name, email, gender, cart_id});
			}
		});
	}

	get baseClassName() {
		return super.baseClassName + " newsletter-subscribe";
	}

	get actionUrl() {
		return router.route("api.newsletter.subscribe");
	}

	get message() {
		return (
			<div><span>Tak!</span> Du er nu medlem af vores nyhedsbrev.</div>
		);
	}

	renderForm() {
		return (
			<div className="klaviyo-form-RwYbFk"></div>
		);
	}
}

class Unsubscribe extends BaseComponent {

	get baseClassName() {
		return super.baseClassName + " newsletter-unsubscribe";
	}

	get actionUrl() {
		return router.route("api.newsletter.unsubscribe");
	}

	get message() {
		return (
			<div><span>Du er nu afmeldt.</span> Vi er kede af du forlader os! Men vi respektere din beslutning!</div>
		);
	}

	renderForm() {
		return (
			<form onSubmit={this.onSubmit}>
				<div className="inputs">
					<div className="field">
						<label htmlFor="input_email">Email</label>
						<input type="email" id="input_email" name="email" required={true}/>
						{this.renderError("email")}
					</div>
				</div>
				<div className="button leftalign">
					<div className="submit-container">
						<input type="submit" value={translate('Afmeld')}/>
					</div>
					<a href={router.route("newsletter.subscribe")}> <Trans>(Jeg ønsker at tilmelde nyhedsbrevet)</Trans></a>
				</div>
			</form>
		);
	}

}

module.exports = {
	Subscribe,
	Unsubscribe
};
